import ArticleCard from "@/components/feature/ArticleCard";
import SectionHeading from "@/components/feature/SectionHeading";
import { articles } from "@/mocks/articles";

export default function EditorPicks() {
  return (
    <section className="w-full bg-background-100 py-10 md:py-14">
      <div className="mx-auto w-full max-w-[1280px] px-4 md:px-6">
        <SectionHeading
          eyebrow="EDITOR'S PICK"
          title="编辑精选"
          subtitle="最新影视资讯与剧情深度解析，由编辑部与特约影评人共同呈现。"
          linkTo="/category/movie"
          linkLabel="浏览全部影视"
        />
        <div className="grid grid-cols-1 gap-3 md:gap-4 lg:grid-cols-2">
          {articles.map((article) => (
            <ArticleCard key={article.id} article={article} />
          ))}
        </div>
      </div>
    </section>
  );
}